export enum EVariableIncomeAcquisitionSteps {
  TEMPLATE,
  INVESTMENT,
  PREVIEW,
  LOADING,
  CONCLUSION
}
